var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7728_231971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0265 15.8333C10.3549 15.8339 10.6802 15.7695 10.9837 15.644C11.2872 15.5184 11.5628 15.3341 11.7948 15.1017L15.0607 11.8333L13.8823 10.6583L10.8548 13.6867L10.8332 0H9.1665L9.18816 13.6733L6.1715 10.6567L4.99316 11.8333L8.259 15.0992C8.49073 15.3319 8.76618 15.5166 9.0695 15.6426C9.37282 15.7686 9.69805 15.8334 10.0265 15.8333Z",
    fill: "#132A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 13.332V17.4987C18.3333 17.7197 18.2455 17.9317 18.0893 18.0879C17.933 18.2442 17.721 18.332 17.5 18.332H2.5C2.27899 18.332 2.06702 18.2442 1.91074 18.0879C1.75446 17.9317 1.66667 17.7197 1.66667 17.4987V13.332H0V17.4987C0 18.1617 0.263392 18.7976 0.732233 19.2665C1.20107 19.7353 1.83696 19.9987 2.5 19.9987H17.5C18.163 19.9987 18.7989 19.7353 19.2678 19.2665C19.7366 18.7976 20 18.1617 20 17.4987V13.332H18.3333Z",
    fill: "#132A4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7728_231971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.ad2fe170bd357a164a32c11e6be6ba03.svg";
export { ForwardRef as ReactComponent };